import { __assign } from "tslib";
import { WidgetActionName, WidgetReferralInfo, } from './bi.const';
import { PlatformBiLoggerAdapter } from '@wix/bookings-adapters-reporting/dist/src/bi-logger/platform-logger/platform-bi-logger-adapter';
import { bookingsTimeTableWidgetLoad, bookingsTimeTableNavigation, bookingsBookItClick, bookingsCantBookGroupsMessage, bookingsWidgetPageLoaded, } from '@wix/bi-logger-wixboost-ugc/v2';
import { bookingsUoUFlowBookInitialIntentSrc16Evid33, bookingsUoUFlowWidgetLoadSrc16Evid32, } from '@wix/bi-logger-bookings-data/v2';
var BiLogger = /** @class */ (function () {
    function BiLogger(wixSdkAdapter, widgetName) {
        this.wixSdkAdapter = wixSdkAdapter;
        this.biLoggerAdapter = new PlatformBiLoggerAdapter({
            wixSdkAdapter: wixSdkAdapter,
            widgetName: widgetName,
        });
    }
    BiLogger.prototype.sendTimetableNavigationEvent = function (data) {
        return this.biLoggerAdapter.report(bookingsTimeTableNavigation(data));
    };
    BiLogger.prototype.sendTimetableLoadedEvent = function (data) {
        return this.biLoggerAdapter.report(bookingsTimeTableWidgetLoad(data));
    };
    BiLogger.prototype.sendBookButtonClickEvent = function (data) {
        return this.biLoggerAdapter.report(bookingsBookItClick(__assign(__assign({}, data), { referralInfo: WidgetReferralInfo.BOOK_BUTTON })));
    };
    BiLogger.prototype.sendTimeTableClickEvent = function (data) {
        return this.biLoggerAdapter.report(bookingsBookItClick({
            actionName: data.action,
            accept_online_bookings: !data.isNoBookFlow,
            service_id: data.serviceId,
            type: data.type,
            is_over_editor: data.isOverEditor,
            isPreview: data.isPreviewMode,
            referralInfo: WidgetReferralInfo.TIME_TABLE,
        }));
    };
    BiLogger.prototype.sendTimetablePremiumPrevention = function () {
        return this.biLoggerAdapter.report(bookingsCantBookGroupsMessage({
            referralInfo: WidgetReferralInfo.TIME_TABLE,
        }));
    };
    BiLogger.prototype.sendStaffWidgetLoaded = function () {
        return this.biLoggerAdapter.report(bookingsWidgetPageLoaded({
            widget_name: WidgetReferralInfo.STAFF_LIST,
        }));
    };
    BiLogger.prototype.sendStaffClicked = function (shouldNavigateToSpecificSitePage) {
        return this.biLoggerAdapter.report(bookingsBookItClick({
            referralInfo: WidgetReferralInfo.STAFF_LIST,
            widget_name: WidgetReferralInfo.STAFF_LIST,
            actionName: shouldNavigateToSpecificSitePage
                ? WidgetActionName.NAVIGATE_TO_SPECIFIC_PAGE
                : WidgetActionName.NAVIGATE_TO_SERVICES_LIST,
        }));
    };
    BiLogger.prototype.sendInitalIntent = function (service) {
        this.biLoggerAdapter.report(bookingsUoUFlowBookInitialIntentSrc16Evid33({
            widget_name: WidgetReferralInfo.BOOK_BUTTON,
            bookingsServiceId: service === null || service === void 0 ? void 0 : service.id,
            serviceType: service === null || service === void 0 ? void 0 : service.type,
        }));
    };
    BiLogger.prototype.sendWidgetLoad = function () {
        this.biLoggerAdapter.report(bookingsUoUFlowWidgetLoadSrc16Evid32({
            widget_name: WidgetReferralInfo.BOOK_BUTTON,
        }));
    };
    return BiLogger;
}());
export { BiLogger };
//# sourceMappingURL=bi-logger.js.map